import React from "react";

export interface ScopeManagementContextType {
  setDefaultsForScopeAndFilter?: boolean;
}

export const ScopeManagementContext =
  React.createContext<ScopeManagementContextType>({});
